// extracted by mini-css-extract-plugin
export default {"bottomSection":"styles_bottomSection__vg8K+","section":"styles_section__f1Iaq"};